<script setup lang="ts">
import {storeToRefs} from "pinia";
import {useSubscriptionPlanStore} from "@/stores/subscription-plan.store";
import {computed} from "vue";
import SubscriptionPlanService from "@/subscription-plan/services/SubscriptionPlanService";
import Icon from "@/core/components/icon/Icon.vue";
import BaseButton from "@/core/components/base/BaseButton.vue";
import {ArrowRight} from "@lucide/vue";
import {useRouter} from "vue-router";

const router = useRouter();

const {globalPlan} = storeToRefs(useSubscriptionPlanStore());

const hasActiveSubscription = computed(() => {
    if (!globalPlan.value) {
        return false;
    }

    return SubscriptionPlanService.hasActiveSubscription(globalPlan.value);
});

const redirect = () => {
    router.push({
        name: 'subscription-plans'
    });
};
</script>

<template>
  <div
    v-if="!hasActiveSubscription"
    class="flex flex-col gap-4 bg-white border p-4 rounded-lg shadow-sm sm:flex-row sm:items-center"
  >
    <div class="flex items-center gap-4 min-w-0">
      <div class="p-3 rounded-lg bg-secondary shrink-0">
        <Icon name="mdi-crown" color="primary" />
      </div>
      <div class="flex flex-col gap-1 min-w-0">
        <div class="flex flex-wrap items-center gap-x-3 gap-y-1">
          <h2>
            Apodis Premium
          </h2>
          <div class="bg-primary/20 rounded-full px-3 shrink-0">
            <span class="text-primary text-xs font-medium whitespace-nowrap">50 SMS offerts / mois</span>
          </div>
        </div>
        <p class="text-sm">
          Recevez <span class="font-medium">50 crédits SMS offerts chaque mois,</span> renouvelés automatiquement
        </p>
      </div>
    </div>
    <BaseButton class="text-primary shrink-0 whitespace-nowrap self-start sm:self-auto sm:ml-auto" @click="redirect()">
      Découvrir
      <ArrowRight class="ml-1 size-4 shrink-0" />
    </BaseButton>
  </div>
</template>

<style scoped>

</style>
